import {defineStore} from 'pinia'
import {CommonNs, type SignUpNs, WorkspaceNs} from "@shared/types";
import {SignUpApi} from "@/api";
import {useUserStore} from "@shared/stores/user.store";
import router from "@/router";
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {setWorkspaceToCookie} from "@shared/helpers";


export const useRegisterStore = defineStore("register", {
    state: () => ({
        registeredUserName: '' as string,
        registeredUserId: 0 as number,
        additionalInfosWorkspaces: [] as WorkspaceNs.Workspace[]
    }),
    getters: {
        getRegisteredUserName: (state): string => state.registeredUserName

    },
    actions: {
        async register(
            payload: SignUpNs.RegisterRequest): Promise<SignUpNs.RegisterResponse> {
            return SignUpApi.register(payload).then((registeredUser) => registeredUser)
        },

        async checkActivationCode(
            payload: SignUpNs.ActivateAccountRequest):
            Promise<SignUpNs.ActivateAccountResponse> {
            return SignUpApi.checkActivationCode(payload)
                .then((activatedAccount: SignUpNs.ActivateAccountResponse) => {
                    return activatedAccount;
                })
        },

        async activateAccount(
            payload: SignUpNs.ActivateAccountRequest): Promise<SignUpNs.ActivateAccountResponse | Error> {
            return SignUpApi.activateAccount(payload).then((activatedAccount) => {
                this.registeredUserName = payload.userName
                return activatedAccount;
            })
        },

        async confirmPrimaryEmail(
            payload: SignUpNs.ActivateAccountRequest
        ): Promise<SignUpNs.ActivateAccountResponse | Error> {
            return SignUpApi.confirmPrimaryEmail(payload)
                .then((response) => response)
        },

        async confirmInvitation(
            payload: SignUpNs.ActivateAccountRequest): Promise<SignUpNs.ActivateAccountResponse | Error> {
            return SignUpApi.confirmInvitation(payload).then((activatedAccount) => {
                this.registeredUserName = payload.userName
                return activatedAccount;
            })
        },

        async goToCreateWorkspace(): Promise<boolean> {
            const userStore = useUserStore();
            this.registeredUserName = userStore.getUserName
            await router.push({name: 'CreateWorkspace'});
            return true;
        },

        async createWorkspace(
            payload: SignUpNs.AddWorkspaceRequest): Promise<SignUpNs.AddWorkspaceResponse> {
            const createdWorkspace = await SignUpApi.addWorkspaces(payload);
            const wsStore = useWorkspaceStore();
            const selectedWs = await wsStore.loadWorkspace(createdWorkspace.workspaceId);
            setWorkspaceToCookie(selectedWs);
            await wsStore.loadUserWorkspaceList();
            return createdWorkspace;
        },

        async inviteMembers(
            payload: SignUpNs.InviteMembersRequest): Promise<CommonNs.GenericResponse> {
            return SignUpApi.inviteMembers(payload).then((response) => response)
        },

        async addUserFeatures(
            payload: SignUpNs.AddUserFeaturesRequest): Promise<CommonNs.GenericResponse> {
            return SignUpApi.addUserFeatures(payload).then((response) => response)
        },

    }

})
